var map = {
	"./article-1.png": 8815,
	"./audrei-1.png": 8575,
	"./consultation.gif": 2115,
	"./defaultAvatar.png": 9663,
	"./doc-lee.jpeg": 8973,
	"./doctor-article.png": 7467,
	"./doctor.png": 4610,
	"./iwc.png": 9148,
	"./logo.svg": 3914,
	"./madel.jpg": 998,
	"./memoji.png": 3066,
	"./nurse.png": 1028,
	"./vin.jpg": 7848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;